import styled from 'styled-components';

import { IconRegularMinus, IconRegularPlus, theme } from '@notino/react-styleguide';

import { Loader } from '@sharedComponents/Loader';

export const IconWrapper = styled.button<{ isVisible?: boolean; isMinus: boolean; enabled: boolean }>`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border-style: hidden;
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: ${({ isVisible = true }) => (isVisible ? 'visible' : 'hidden')};
  opacity: ${({ isVisible = true }) => (isVisible ? 1 : 0)};
  --offset: 0;
  &:hover {
    cursor: pointer;
  }
`;

export const StyledIconRegularMinus = styled(IconRegularMinus)`
  width: 0.75rem;
  height: 0.75rem;
`;

export const StyledIconRegularPlus = styled(IconRegularPlus)`
  width: 1rem;
  height: 1rem;
`;
export const StyledLoader = styled(Loader)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  margin: 0 1rem;
  height: 0.75rem;
  color: ${theme.color.text.primary};
`;

export const QuantityUnit = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${theme.color.text.primary};
  font-weight: normal;
`;

export const QuantityUnitHidden = styled.span`
  position: absolute;
  width: 1rem;
  height: 1rem;
  padding: 0rem;
  margin: -1rem;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const QuantityValue = styled.span<{ enabled?: boolean; showUnit?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 1rem;
  color: ${theme.color.text.primary};
  font-weight: ${({ enabled = true }) => (enabled ? 'bold' : 'normal')};
  margin: ${({ showUnit }) => (showUnit ? '0' : '0 1rem')};
`;
